import { PrintQueueStatusSchema } from "@redotech/redo-fulfillment-printing-common/print-queue-status";
import * as z from "zod";

export const dismissPrintJobs = {
  name: "dismissPrintJobs" as const,
  input: z.object({ printJobs: z.array(z.string()) }),
  output: PrintQueueStatusSchema,
};

export type DismissPrintJobsInput = z.infer<typeof dismissPrintJobs.input>;
